export default __webpack_public_path__ + "static/media/grey-circle.53d49fef.svg";